import { Stack, Button } from '@mui/material';
import {
    Title,
    ListToolbar,
    BulkActionsToolbar,
    BulkDeleteButton,
    Pagination,
    TopToolbar,
} from 'ra-ui-materialui';
import { useState } from 'react';
import { MediaIterator } from './MediaIterator';
import { MediaUploadDialog } from './MediaUploadDialog';
import { MediaListFilter } from './MediaListFilter';
import { MissionId, ResourceCategory } from '@wwf/sdk';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useRefresh, useDataProvider, SortButton } from 'react-admin';
import type { CrmDataProvider } from '@core/providers';

export const MediaGridLayout = ({ missionId }: { missionId?: MissionId }) => {
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const refresh = useRefresh();
    const dataProvider = useDataProvider<CrmDataProvider>();

    const handleUploadSuccess = async (resources: any[]) => {
        // Link resources to mission if missionId is provided
        if (missionId && resources.length > 0) {
            try {
                await Promise.all(
                    resources.map(resource =>
                        dataProvider.linkResourceToMission(
                            missionId,
                            resource.id
                        )
                    )
                );
            } catch (error) {
                console.error('Failed to link resources to mission:', error);
            }
        }
        refresh();
    };

    return (
        <Stack sx={{ width: '100%' }}>
            <Title title={'medias'} />
            <ListToolbar
                actions={
                    <TopToolbar
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Stack direction="row" alignItems="center" gap={2}>
                            <MediaListFilter />
                            <SortButton fields={['createdAt', 'updatedAt']} />
                        </Stack>
                        {missionId && (
                            <>
                                <Button
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={() => setUploadDialogOpen(true)}
                                >
                                    Upload Media
                                </Button>
                                <MediaUploadDialog
                                    open={uploadDialogOpen}
                                    onClose={() => setUploadDialogOpen(false)}
                                    category={ResourceCategory.missions}
                                    onSuccess={handleUploadSuccess}
                                />
                            </>
                        )}
                    </TopToolbar>
                }
            />
            <BulkActionsToolbar>
                {/* <BulkExportButton exporter={missionExporter} /> */}
                <BulkDeleteButton />
            </BulkActionsToolbar>
            <MediaIterator />
            <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
        </Stack>
    );
};
